import { useState } from "react";
import { Share2, Copy, X, Check } from "lucide-react";
import { toast } from "sonner";

export default function SharePG({ property, baseUrl = "https://hostro.in" }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const url = `${baseUrl}/properties/${property.id}`;
  const title = property.title || "PG on Hostro";
  const text = `🏠 ${title} on @hostro_in — verified PG in ${property.city || "India"} starting at ₹${(property.price_per_month || 0).toLocaleString()}/month. Book online: ${url}`;

  const tweet = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
  const whatsapp = `https://wa.me/?text=${encodeURIComponent(text)}`;
  const facebook = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`;
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Link copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <button onClick={()=>setOpen(true)} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl border border-gray-200 bg-white hover:border-[#34C97B] hover:text-[#22B36A] text-sm font-semibold transition" data-testid="share-btn">
        <Share2 size={14}/> Share
      </button>

      {open && (
        <div className="fixed inset-0 z-[70] bg-black/40 backdrop-blur-sm grid place-items-center p-5" onClick={()=>setOpen(false)} data-testid="share-modal">
          <div className="bg-white rounded-3xl border border-gray-200 p-6 max-w-md w-full" onClick={e=>e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h3 className="font-display font-black text-2xl text-[#111111]">Share this PG</h3>
              <button onClick={()=>setOpen(false)} className="p-2 rounded-full hover:bg-gray-100"><X size={18}/></button>
            </div>

            {/* Preview */}
            <div className="bg-gray-50 rounded-xl p-4 mb-5">
              <div className="font-bold text-sm text-[#111111] line-clamp-2">{title}</div>
              <div className="text-xs text-gray-500 mt-1">starting at ₹{(property.price_per_month || 0).toLocaleString()}/month</div>
            </div>

            {/* Social buttons */}
            <div className="grid grid-cols-2 gap-2">
              <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#25D366] hover:bg-[#1FB857] text-white font-semibold text-sm transition" data-testid="share-whatsapp">
                WhatsApp
              </a>
              <a href={tweet} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#111111] hover:bg-black text-white font-semibold text-sm transition" data-testid="share-twitter">
                X / Twitter
              </a>
              <a href={facebook} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#1877F2] hover:bg-[#0F60D8] text-white font-semibold text-sm transition" data-testid="share-facebook">
                Facebook
              </a>
              <a href={linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#0A66C2] hover:bg-[#084FA1] text-white font-semibold text-sm transition" data-testid="share-linkedin">
                LinkedIn
              </a>
            </div>

            {/* Copy link */}
            <div className="mt-3 flex gap-2">
              <input readOnly value={url} className="flex-1 px-3 py-2.5 rounded-xl border border-gray-200 text-xs text-gray-600 outline-none bg-gray-50"/>
              <button onClick={copyLink} className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-[#34C97B] hover:bg-[#22B36A] text-white font-semibold text-sm transition" data-testid="copy-link-btn">
                {copied ? <><Check size={14}/> Copied</> : <><Copy size={14}/> Copy</>}
              </button>
            </div>

            <p className="text-xs text-gray-400 mt-4 text-center">
              Sharing helps fellow students find verified PGs. Every share = potential ₹500 referral.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
